'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _description = require('./description.component');

var _description2 = _interopRequireDefault(_description);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var descriptionModule = _angular2.default.module('description', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('dashboard.detail.description', {
    url: '/description',
    component: 'description'
    // params: {
    //   item: null,
    //   language: "IT"
    // }
  });
}).component('description', _description2.default).name;

exports.default = descriptionModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/description/description.js